import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";


const BackButton = ({ text, imageUrl, imageAlt, clickEvent }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (clickEvent) {
      clickEvent();
    } else {
      navigate(-1);
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 cursor-pointer h-[50px] md:h-[70px] flex items-center justify-center w-full px-[18px] mx-auto bg-white z-30 max-w-[900px] min-w-[320px]"
      onClick={handleClick}
    >
      <ChevronLeft className="w-[26px] h-[26px] md:w-[30px] md:h-[30px] absolute left-[18px]" />
      
      {imageUrl ? (
        <>
        <div className="relative h-[30px] md:h-[40px] flex items-center justify-center mr-[10px]">
          <img
            src={imageUrl}
            alt={imageAlt || "Header image"}
            className="object-contain w-[90px] md:w-[100px]"
          />
        </div>
        <span className="text-[18px] md:text-xl font-semibold text-[#FFAF58]">홈으로 가기</span>
        </>
      ) : (
        <p className="text-base md:text-xl font-semibold">{text}</p>
      )}
    </div>
  );
};

export default BackButton;
